var configs = {
    insertMethod: 'append',
    insertSelector: 'body'
};
export default configs;



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/addons/fixedelements/_configs.js
// module id = 63
// module chunks = 0